import React from "react";
import { posters } from "../../Constants";
import { PosterCarousel } from "../../Components";
import { useStyles } from "./GalleryImage.styles";
interface Props {}

export const GalleryImage: React.FC<Props> = () => {
  const classes = useStyles();
  return (
    <div className={classes.galleryImage_root}>
      <PosterCarousel posters={posters} />
    </div>
  );
};
